import React, { useState, useEffect } from 'react';
import { TopNav, SideNav } from '../navigation/ConsoleNavigation';
import TextractorWorkspace from './TextractorWorkspace';
import { useLocation } from 'react-router-dom';

const TextractorDashboard = () => {
  const location = useLocation();

  // SLR context arriving via route state (legacy entry point — still supported)
  const [fabricIdFromSLR, setFabricIdFromSLR] = useState(null);
  const [gridThreadIdFromSLR, setGridThreadIdFromSLR] = useState(null);

  useEffect(() => {
    // Coming from SLR → lock Textractor to that fabric
    if (location.state?.fromSLR && location.state?.fabricId) {
      setFabricIdFromSLR(location.state.fabricId);
      setGridThreadIdFromSLR(location.state?.gridThreadId || null);
      return;
    }

    // If navigation explicitly says "not from SLR", then clear
    if (location.state && location.state.fromSLR === false) {
      setFabricIdFromSLR(null);
      setGridThreadIdFromSLR(null);
    }
  }, [location.state]);

  return (
    <div className="main-window">
      <TopNav />
      <div className="container-fluid has-inner-panel has-dashboard-header">
        <div className="row">
          <SideNav />
          <main className="col-12 col-md-9 col-lg-10 ms-sm-auto console-main-window">
            <TextractorWorkspace
              fabricId={fabricIdFromSLR}
              gridThreadId={gridThreadIdFromSLR}
            />
          </main>
        </div>
      </div>
    </div>
  );
};

export default TextractorDashboard;